(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-circle-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ELEMENT_NAME = 'collection-circle-carousel';

  if (customElements.get(ELEMENT_NAME)) return;

  class CollectionCircleCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-carousel-viewport]');
      this.track = this.querySelector('[data-carousel-track]');
      this.previousButton = this.querySelector('[data-carousel-previous]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.counter = this.querySelector('[data-carousel-counter]');

      if (!this.viewport || !this.track || this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.delay = Math.max(1000, Number(this.dataset.autoplayDelay) || 3000);
      this.transitionDuration = Math.max(0, Number(this.dataset.transitionDuration) || 600);
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.logicalIndex = 0;
      this.index = 0;
      this.cloneCount = 0;
      this.slideStep = 0;
      this.timer = null;
      this.dragging = false;
      this.dragged = false;
      this.startX = 0;
      this.startTranslate = 0;
      this.currentTranslate = 0;
      this.animating = false;

      this.onPrevious = () => this.move(-1, true);
      this.onNext = () => this.move(1, true);
      this.onTransitionEnd = (event) => {
        if (event.target !== this.track || event.propertyName !== 'transform') return;
        this.animating = false;
        this.normalizeLoopPosition();
      };
      this.onKeydown = (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(-1, true);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(1, true);
        }
      };
      this.onPointerDown = (event) => this.pointerDown(event);
      this.onPointerMove = (event) => this.pointerMove(event);
      this.onPointerUp = (event) => this.pointerUp(event);
      this.onDragStart = (event) => event.preventDefault();
      this.onWheel = (event) => this.wheelScroll(event);
      this.onClickCapture = (event) => {
        if (!this.dragged) return;
        event.preventDefault();
        event.stopPropagation();
        this.dragged = false;
      };
      this.onVisibilityChange = () => document.hidden ? this.stopAutoplay() : this.startAutoplay();
      this.onMouseEnter = () => this.pauseOnHover && this.stopAutoplay();
      this.onMouseLeave = () => this.startAutoplay();
      this.onFocusIn = () => this.stopAutoplay();
      this.onFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) this.startAutoplay();
      };

      this.previousButton?.addEventListener('click', this.onPrevious);
      this.nextButton?.addEventListener('click', this.onNext);
      this.track.addEventListener('transitionend', this.onTransitionEnd);
      this.viewport.addEventListener('keydown', this.onKeydown);
      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      this.viewport.addEventListener('pointermove', this.onPointerMove);
      this.viewport.addEventListener('pointerup', this.onPointerUp);
      this.viewport.addEventListener('pointercancel', this.onPointerUp);
      this.viewport.addEventListener('dragstart', this.onDragStart);
      this.viewport.addEventListener('wheel', this.onWheel, { passive: false });
      this.viewport.addEventListener('click', this.onClickCapture, true);
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      this.resizeObserver = new ResizeObserver(() => this.queueBuild());
      this.resizeObserver.observe(this.viewport);
      this.build();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.buildFrame);
      this.previousButton?.removeEventListener('click', this.onPrevious);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('transitionend', this.onTransitionEnd);
      this.viewport?.removeEventListener('keydown', this.onKeydown);
      this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
      this.viewport?.removeEventListener('pointermove', this.onPointerMove);
      this.viewport?.removeEventListener('pointerup', this.onPointerUp);
      this.viewport?.removeEventListener('pointercancel', this.onPointerUp);
      this.viewport?.removeEventListener('dragstart', this.onDragStart);
      this.viewport?.removeEventListener('wheel', this.onWheel);
      this.viewport?.removeEventListener('click', this.onClickCapture, true);
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.dataset.initialized = 'false';
    }

    get originals() {
      return Array.from(this.track.children).filter((slide) => slide.dataset.carouselClone !== 'true');
    }

    queueBuild() {
      cancelAnimationFrame(this.buildFrame);
      this.buildFrame = requestAnimationFrame(() => this.build());
    }

    build() {
      this.stopAutoplay();
      this.track.querySelectorAll('[data-carousel-clone="true"]').forEach((clone) => clone.remove());

      const slides = this.originals;
      const disabled = slides.length === 0;
      if (this.previousButton) this.previousButton.disabled = disabled;
      if (this.nextButton) this.nextButton.disabled = disabled;
      if (!slides.length) return;

      const slideWidth = slides[0].getBoundingClientRect().width;
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      this.slideStep = Math.max(1, slideWidth + gap);
      const visibleCount = Math.max(1, Math.ceil((this.viewport.clientWidth + gap) / this.slideStep));

      /*
       * Repeat the real sequence until both sides are wider than the viewport.
       * Capping clones to slides.length leaves a blank edge when, for example,
       * three real cards are displayed inside a seven-card-wide viewport.
       */
      this.cloneCount = visibleCount + 2;
      const before = document.createDocumentFragment();
      const after = document.createDocumentFragment();

      for (let cloneIndex = -this.cloneCount; cloneIndex < 0; cloneIndex += 1) {
        before.append(this.makeClone(slides[this.mod(cloneIndex, slides.length)]));
      }

      for (let cloneIndex = 0; cloneIndex < this.cloneCount; cloneIndex += 1) {
        after.append(this.makeClone(slides[this.mod(cloneIndex, slides.length)]));
      }

      this.track.insertBefore(before, slides[0]);
      this.track.append(after);

      this.index = this.cloneCount + (this.logicalIndex % slides.length);
      this.goTo(this.index, false);
      this.updateCounter();
      this.startAutoplay();
    }

    makeClone(slide) {
      const clone = slide.cloneNode(true);
      clone.dataset.carouselClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');
      clone.removeAttribute('data-block-id');
      clone.removeAttribute('data-shopify-editor-block');
      clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((node) => node.setAttribute('tabindex', '-1'));
      return clone;
    }

    move(direction, userInitiated = false) {
      if (!this.originals.length || this.dragging || this.animating) return;
      this.index += direction;
      this.logicalIndex = this.mod(this.index - this.cloneCount, this.originals.length);
      this.goTo(this.index, true);
      this.updateCounter();

      if (userInitiated) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    goTo(index, animate) {
      const slide = this.track.children[index];
      if (!slide) return;

      this.track.style.transition = animate ? `transform ${this.transitionDuration}ms cubic-bezier(.22,.61,.36,1)` : 'none';
      this.animating = animate;
      const centerOffset = window.matchMedia('(max-width: 749px)').matches
        ? (this.viewport.clientWidth - slide.getBoundingClientRect().width) / 2
        : 0;
      this.currentTranslate = -slide.offsetLeft + centerOffset;
      this.track.style.transform = `translate3d(${this.currentTranslate}px, 0, 0)`;
    }

    normalizeLoopPosition() {
      const count = this.originals.length;
      if (!count) return;

      if (this.index >= this.cloneCount + count) {
        this.index = this.cloneCount + this.mod(this.index - this.cloneCount, count);
        this.goTo(this.index, false);
      } else if (this.index < this.cloneCount) {
        this.index = this.cloneCount + this.mod(this.index - this.cloneCount, count);
        this.goTo(this.index, false);
      }
    }

    pointerDown(event) {
      if ((event.button !== undefined && event.button !== 0) || this.animating) return;
      this.dragging = true;
      this.dragged = false;
      this.startX = event.clientX;
      this.startTranslate = this.currentTranslate;
      this.viewport.classList.add('is-dragging');
      this.track.style.transition = 'none';
      this.stopAutoplay();
    }

    pointerMove(event) {
      if (!this.dragging) return;
      const distance = event.clientX - this.startX;
      if (Math.abs(distance) > 6) {
        if (!this.dragged) this.viewport.setPointerCapture?.(event.pointerId);
        this.dragged = true;
        event.preventDefault();
      }
      if (!this.dragged) return;
      this.currentTranslate = this.startTranslate + distance;
      this.track.style.transform = `translate3d(${this.currentTranslate}px, 0, 0)`;
    }

    pointerUp(event) {
      if (!this.dragging) return;
      const distance = event.clientX - this.startX;
      this.dragging = false;
      this.viewport.classList.remove('is-dragging');
      if (this.viewport.hasPointerCapture?.(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);

      if (!this.dragged) {
        this.startAutoplay();
        return;
      }

      const threshold = Math.min(52, Math.max(22, this.slideStep * .16));
      if (Math.abs(distance) > threshold) {
        const requestedSteps = Math.max(1, Math.round(Math.abs(distance) / Math.max(1, this.slideStep)));
        const steps = Math.min(requestedSteps, Math.max(1, this.cloneCount - 1));
        this.move((distance < 0 ? 1 : -1) * steps, true);
      } else {
        this.goTo(this.index, true);
      }
      window.setTimeout(() => { this.dragged = false; }, 0);
      this.startAutoplay();
    }

    wheelScroll(event) {
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) || Math.abs(event.deltaX) < 8) return;
      event.preventDefault();
      if (this.wheelLocked || this.dragging || this.animating) return;
      this.wheelLocked = true;
      this.move(event.deltaX > 0 ? 1 : -1, true);
      window.setTimeout(() => {
        this.wheelLocked = false;
      }, this.transitionDuration + 80);
    }

    startAutoplay() {
      this.stopAutoplay();
      if (!this.autoplayEnabled || this.reducedMotion.matches || document.hidden || !this.originals.length) return;
      this.timer = window.setInterval(() => this.move(1), this.delay);
    }

    stopAutoplay() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    updateCounter() {
      if (!this.counter) return;
      const total = this.originals.length;
      this.counter.textContent = `${this.logicalIndex + 1} / ${total}`;
    }

    selectBlock(blockId) {
      const slides = this.originals;
      const targetIndex = slides.findIndex((slide) => slide.dataset.blockId === blockId);
      if (targetIndex < 0) return;
      this.logicalIndex = targetIndex;
      this.index = this.cloneCount + targetIndex;
      this.goTo(this.index, true);
      this.updateCounter();
      this.stopAutoplay();
    }

    mod(value, divisor) {
      return ((value % divisor) + divisor) % divisor;
    }
  }

  customElements.define(ELEMENT_NAME, CollectionCircleCarousel);

  document.addEventListener('shopify:block:select', (event) => {
    event.target.closest(ELEMENT_NAME)?.selectBlock(event.detail.blockId);
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    event.target.closest(ELEMENT_NAME)?.startAutoplay();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-premium-product-detail"] && !Shopify.designMode) return;
  try {
    
(() => {
  const name = 'premium-product-detail';
  if (customElements.get(name)) return;

  class PremiumProductDetail extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.mainMedia = this.querySelector('[data-ppd-main-media]');
      this.variantInput = this.querySelector('[data-variant-id]');
      this.variantData = this.parseVariants();
      this.galleryAutoplay = this.dataset.galleryAutoplay === 'true';
      this.galleryDelay = Math.max(1000, Number(this.dataset.galleryDelay) || 5000);
      this.featuresAutoplay = this.dataset.featuresAutoplay === 'true';
      this.featuresDelay = Math.max(1000, Number(this.dataset.featuresDelay) || 3000);
      this.featuresDuration = Math.max(0, Number(this.dataset.featuresTransition) || 500);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.bindGallery();
      this.bindFeatureCarousel();
      this.setupMobileRelocation();
      this.bindOptions();
      this.syncInitialVariant();
      this.bindQuantity();
      this.bindMantra();
      this.bindAddToCart();
      this.bindBuyNow();
      this.onVisibilityChange = () => {
        if (document.hidden) {
          this.stopGalleryAutoplay();
          this.stopFeatureAutoplay();
        } else {
          this.startGalleryAutoplay();
          this.startFeatureAutoplay();
        }
      };
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    disconnectedCallback() {
      this.stopGalleryAutoplay();
      this.stopFeatureAutoplay();
      window.clearTimeout(this.featureTransitionFallback);
      this.featureTrack?.removeEventListener('transitionend', this.onFeatureTransitionEnd);
      if (this.mobileQuery?.removeEventListener) this.mobileQuery.removeEventListener('change', this.onMobileChange);
      else this.mobileQuery?.removeListener?.(this.onMobileChange);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    parseVariants() {
      const node = this.querySelector('[data-ppd-variants]');
      if (!node) return [];
      try { return JSON.parse(node.textContent); } catch (error) { return []; }
    }

    bindGallery() {
      this.thumbButtons = Array.from(this.querySelectorAll('.ppd-gallery__thumb'));
      this.thumbButtons.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.setMainImage(thumb.dataset.imageSrc, thumb.dataset.imageAlt, thumb.dataset.mediaId, thumb.dataset.imageWidth, thumb.dataset.imageHeight);
          this.startGalleryAutoplay();
        });
      });
      this.thumbsScroller = this.querySelector('[data-ppd-thumbs]');
      this.querySelector('[data-thumbs-previous]')?.addEventListener('click', () => this.thumbsScroller?.scrollBy({ left: -220, behavior: 'smooth' }));
      this.querySelector('[data-thumbs-next]')?.addEventListener('click', () => this.thumbsScroller?.scrollBy({ left: 220, behavior: 'smooth' }));
      const gallery = this.querySelector('.ppd-gallery');
      gallery?.addEventListener('mouseenter', () => this.stopGalleryAutoplay());
      gallery?.addEventListener('mouseleave', () => this.startGalleryAutoplay());
      gallery?.addEventListener('focusin', () => this.stopGalleryAutoplay());
      gallery?.addEventListener('focusout', (event) => { if (!gallery.contains(event.relatedTarget)) this.startGalleryAutoplay(); });
      this.startGalleryAutoplay();
    }

    setMainImage(src, alt = '', mediaId = '', width = '', height = '') {
      const image = this.mainMedia?.querySelector('img');
      if (!image || !src) return;
      image.srcset = '';
      image.src = src;
      image.alt = alt;
      if (Number(width) > 0 && Number(height) > 0) {
        image.width = width;
        image.height = height;
      }
      this.querySelectorAll('.ppd-gallery__thumb').forEach((thumb) => thumb.classList.toggle('is-active', String(thumb.dataset.mediaId) === String(mediaId)));
    }

    startGalleryAutoplay() {
      this.stopGalleryAutoplay();
      if (!this.galleryAutoplay || this.reducedMotion.matches || document.hidden || this.thumbButtons.length < 2) return;
      this.galleryTimer = window.setInterval(() => {
        const activeIndex = this.thumbButtons.findIndex((thumb) => thumb.classList.contains('is-active'));
        const next = this.thumbButtons[(activeIndex + 1 + this.thumbButtons.length) % this.thumbButtons.length];
        if (!next) return;
        this.setMainImage(next.dataset.imageSrc, next.dataset.imageAlt, next.dataset.mediaId, next.dataset.imageWidth, next.dataset.imageHeight);
        const centeredLeft = next.offsetLeft - ((this.thumbsScroller?.clientWidth || 0) - next.clientWidth) / 2;
        this.thumbsScroller?.scrollTo({ left: Math.max(0, centeredLeft), behavior: 'smooth' });
      }, this.galleryDelay);
    }

    stopGalleryAutoplay() {
      if (this.galleryTimer) window.clearInterval(this.galleryTimer);
      this.galleryTimer = null;
    }

    bindFeatureCarousel() {
      this.featureViewport = this.querySelector('[data-feature-carousel]');
      this.featureTrack = this.querySelector('[data-feature-track]');
      if (!this.featureViewport || !this.featureTrack || this.featureTrack.children.length < 2) return;

      this.featureAnimating = false;
      this.featureDragging = false;
      this.featureStartX = 0;
      this.featurePendingDirection = 0;
      this.onFeatureTransitionEnd = (event) => {
        if (event.target === this.featureTrack && event.propertyName === 'transform') this.finishFeatureMove();
      };
      this.featureTrack.addEventListener('transitionend', this.onFeatureTransitionEnd);
      this.featureViewport.addEventListener('mouseenter', () => this.stopFeatureAutoplay());
      this.featureViewport.addEventListener('mouseleave', () => this.startFeatureAutoplay());
      this.featureViewport.addEventListener('focusin', () => this.stopFeatureAutoplay());
      this.featureViewport.addEventListener('focusout', (event) => { if (!this.featureViewport.contains(event.relatedTarget)) this.startFeatureAutoplay(); });
      this.featureViewport.addEventListener('pointerdown', (event) => this.featurePointerDown(event));
      this.featureViewport.addEventListener('pointermove', (event) => this.featurePointerMove(event));
      this.featureViewport.addEventListener('pointerup', (event) => this.featurePointerUp(event));
      this.featureViewport.addEventListener('pointercancel', (event) => this.featurePointerUp(event));
      this.startFeatureAutoplay();
    }

    featureCanMove() {
      return this.featureTrack && this.featureViewport && this.featureTrack.scrollWidth > this.featureViewport.clientWidth + 1;
    }

    moveFeature(direction = 1) {
      if (!this.featureCanMove() || this.featureAnimating || this.featureDragging) return;
      this.stopFeatureAutoplay();
      this.featureAnimating = true;
      this.featurePendingDirection = direction;
      const first = this.featureTrack.firstElementChild;
      const movingItem = direction < 0 ? this.featureTrack.lastElementChild : first;
      const styles = getComputedStyle(this.featureTrack);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const step = movingItem.getBoundingClientRect().width + gap;

      if (direction < 0) {
        this.featureTrack.insertBefore(this.featureTrack.lastElementChild, first);
        this.featureTrack.style.transition = 'none';
        this.featureTrack.style.transform = `translate3d(${-step}px,0,0)`;
        this.featureTrack.getBoundingClientRect();
        requestAnimationFrame(() => {
          this.featureTrack.style.transition = `transform ${this.featuresDuration}ms cubic-bezier(.22,.61,.36,1)`;
          this.featureTrack.style.transform = 'translate3d(0,0,0)';
        });
      } else {
        this.featureTrack.style.transition = `transform ${this.featuresDuration}ms cubic-bezier(.22,.61,.36,1)`;
        this.featureTrack.style.transform = `translate3d(${-step}px,0,0)`;
      }

      window.clearTimeout(this.featureTransitionFallback);
      this.featureTransitionFallback = window.setTimeout(() => this.finishFeatureMove(), this.featuresDuration + 100);
    }

    finishFeatureMove() {
      if (!this.featureAnimating) return;
      window.clearTimeout(this.featureTransitionFallback);
      if (this.featurePendingDirection > 0 && this.featureTrack.firstElementChild) this.featureTrack.append(this.featureTrack.firstElementChild);
      this.featureTrack.style.transition = 'none';
      this.featureTrack.style.transform = 'translate3d(0,0,0)';
      this.featureAnimating = false;
      this.featurePendingDirection = 0;
      this.startFeatureAutoplay();
    }

    featurePointerDown(event) {
      if (!this.featureCanMove() || this.featureAnimating || (event.button !== undefined && event.button !== 0)) return;
      this.featureDragging = true;
      this.featureStartX = event.clientX;
      this.featureTrack.style.transition = 'none';
      this.featureViewport.classList.add('is-dragging');
      this.featureViewport.setPointerCapture?.(event.pointerId);
      this.stopFeatureAutoplay();
    }

    featurePointerMove(event) {
      if (!this.featureDragging) return;
      const distance = event.clientX - this.featureStartX;
      if (Math.abs(distance) < 4) return;
      this.featureTrack.style.transform = `translate3d(${distance}px,0,0)`;
    }

    featurePointerUp(event) {
      if (!this.featureDragging) return;
      const distance = event.clientX - this.featureStartX;
      this.featureDragging = false;
      this.featureViewport.classList.remove('is-dragging');
      this.featureViewport.releasePointerCapture?.(event.pointerId);

      if (distance < -36) {
        const first = this.featureTrack.firstElementChild;
        const styles = getComputedStyle(this.featureTrack);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        const step = first.getBoundingClientRect().width + gap;
        this.featureAnimating = true;
        this.featurePendingDirection = 1;
        this.featureTrack.style.transition = `transform ${this.featuresDuration}ms cubic-bezier(.22,.61,.36,1)`;
        this.featureTrack.style.transform = `translate3d(${-step}px,0,0)`;
        window.clearTimeout(this.featureTransitionFallback);
        this.featureTransitionFallback = window.setTimeout(() => this.finishFeatureMove(), this.featuresDuration + 100);
        return;
      }

      if (distance > 36) {
        this.featureTrack.style.transition = 'none';
        this.featureTrack.style.transform = 'translate3d(0,0,0)';
        requestAnimationFrame(() => this.moveFeature(-1));
        return;
      }

      this.featureTrack.style.transition = `transform ${Math.min(250, this.featuresDuration)}ms ease`;
      this.featureTrack.style.transform = 'translate3d(0,0,0)';
      window.setTimeout(() => this.startFeatureAutoplay(), Math.min(250, this.featuresDuration));
    }

    startFeatureAutoplay() {
      this.stopFeatureAutoplay();
      if (!this.featuresAutoplay || this.reducedMotion.matches || document.hidden || !this.featureCanMove()) return;
      this.featureTimer = window.setInterval(() => this.moveFeature(1), this.featuresDelay);
    }

    stopFeatureAutoplay() {
      if (this.featureTimer) window.clearInterval(this.featureTimer);
      this.featureTimer = null;
    }

    setupMobileRelocation() {
      this.mobileBottomContainer = this.querySelector('[data-mobile-bottom-container]');
      const nodes = Array.from(this.querySelectorAll('[data-mobile-bottom-block]'));
      if (!this.mobileBottomContainer || !nodes.length) return;
      this.mobileBlocks = nodes.map((node) => {
        const marker = document.createComment('premium-product-mobile-position');
        node.before(marker);
        return { node, marker };
      });
      this.mobileQuery = window.matchMedia('(max-width: 989px)');
      this.onMobileChange = () => {
        this.mobileBlocks.forEach(({ node, marker }) => {
          if (this.mobileQuery.matches) this.mobileBottomContainer.append(node);
          else marker.parentNode?.insertBefore(node, marker.nextSibling);
        });
      };
      if (this.mobileQuery.addEventListener) this.mobileQuery.addEventListener('change', this.onMobileChange);
      else this.mobileQuery.addListener?.(this.onMobileChange);
      this.onMobileChange();
    }

    bindOptions() {
      this.querySelectorAll('[data-variant-option]').forEach((input) => input.addEventListener('change', () => this.updateVariant()));
    }

    syncInitialVariant() {
      if (!this.variantInput || !this.variantData.length) return;
      const selectedVariant = this.variantData.find((variant) => String(variant.id) === String(this.variantInput.value));
      const availableVariant = selectedVariant?.available
        ? selectedVariant
        : this.variantData.find((variant) => variant.available);
      if (!availableVariant) {
        this.setPurchaseState(null);
        return;
      }

      if (!selectedVariant?.available) {
        this.variantInput.value = availableVariant.id;
        this.applyVariantOptions(availableVariant.options);
      }
      this.renderVariant(availableVariant);
    }

    applyVariantOptions(options) {
      options.forEach((value, index) => {
        const position = index + 1;
        this.querySelectorAll(`[data-variant-option][data-option-position="${position}"]`).forEach((input) => {
          if (input.type === 'radio') input.checked = input.value === value;
          else input.value = value;
        });
      });
    }

    selectedOptions() {
      const values = [];
      this.querySelectorAll('[data-variant-option]').forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        if ((input.type === 'radio' && input.checked) || input.type === 'hidden' || input.tagName === 'SELECT') values[position] = input.value;
      });
      return values;
    }

    updateVariant() {
      const selected = this.selectedOptions();
      const variant = this.variantData.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) {
        this.setPurchaseState(null);
        return;
      }
      if (this.variantInput) this.variantInput.value = variant.id;
      this.renderVariant(variant);
    }

    renderVariant(variant) {
      const price = this.querySelector('[data-variant-price]');
      const compare = this.querySelector('[data-variant-compare]');
      const save = this.querySelector('[data-variant-save]');
      const saving = this.querySelector('[data-variant-saving]');
      if (price) price.textContent = variant.price;
      if (compare) { compare.textContent = variant.compare; compare.hidden = !variant.compare; }
      if (save) save.hidden = !variant.saving;
      if (saving) saving.textContent = variant.saving;
      this.setPurchaseState(variant);
      if (variant.image) this.setMainImage(variant.image, variant.alt, variant.mediaId, variant.imageWidth, variant.imageHeight);
    }

    setPurchaseState(variant) {
      const isAvailable = Boolean(variant?.available);
      const add = this.querySelector('[data-add-to-cart]');
      const buyNow = this.querySelector('[data-buy-now]');
      if (add) {
        add.disabled = !isAvailable;
        add.setAttribute('aria-disabled', String(!isAvailable));
        const label = add.querySelector('span');
        if (label) label.textContent = isAvailable ? add.dataset.addLabel : add.dataset.soldLabel;
      }
      if (buyNow) {
        buyNow.disabled = !isAvailable;
        buyNow.setAttribute('aria-disabled', String(!isAvailable));
      }
    }

    bindQuantity() {
      const input = this.querySelector('.ppd-quantity input');
      this.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { if (input) input.value = Math.max(1, Number(input.value) - 1); });
      this.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { if (input) input.value = Math.max(1, Number(input.value) + 1); });
    }

    bindMantra() {
      const button = this.querySelector('[data-mantra-add]');
      button?.addEventListener('click', () => {
        button.classList.toggle('is-added');
        button.textContent = button.classList.contains('is-added') ? 'Added ✓' : button.dataset.originalLabel || 'Add';
      });
      if (button) button.dataset.originalLabel = button.textContent;
    }

    bindAddToCart() {
      const form = this.querySelector('.ppd-form');
      const button = this.querySelector('[data-add-to-cart]');
      if (!form || !button) return;

      // Capture the submit before the theme-wide product-form handler. This
      // section has its own variant controls, error UI and cart-drawer flow.
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

        const selectedVariant = this.variantData.find((variant) => String(variant.id) === String(this.variantInput?.value));
        if (!selectedVariant?.available) {
          this.showCartError('This product is currently unavailable. Please refresh the page and try again.');
          return;
        }

        const drawer = document.querySelector('cart-drawer');
        const formData = new FormData(form);
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          formData.set('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
          formData.set('sections_url', window.location.pathname);
          drawer.setActiveElement?.(button);
        }

        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        button.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
        this.showCartError();

        try {
          const configuredUrl = window.routes?.cart_add_url || form.action || '/cart/add';
          const cartAddUrl = new URL(configuredUrl, window.location.origin);
          if (!cartAddUrl.pathname.endsWith('.js')) cartAddUrl.pathname = `${cartAddUrl.pathname}.js`;

          const response = await fetch(cartAddUrl.toString(), {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(state.description || 'Unable to add this product.');

          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(state);
            drawer.open?.(button);
          } else {
            window.location.assign(window.routes?.cart_url || '/cart');
          }
        } catch (error) {
          this.showCartError(error.message || 'Unable to add this product. Please try again.');
        } finally {
          button.classList.remove('loading');
          button.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          if (selectedVariant.available) button.removeAttribute('aria-disabled');
        }
      }, true);
    }

    showCartError(message = '') {
      const wrapper = this.querySelector('.ppd-form-error');
      const output = wrapper?.querySelector('.product-form__error-message');
      if (!wrapper || !output) return;
      output.textContent = message;
      wrapper.hidden = !message;
    }

    bindBuyNow() {
      this.querySelector('[data-buy-now]')?.addEventListener('click', () => {
        const sourceForm = this.querySelector('.ppd-form');
        const selectedVariant = this.variantData.find((variant) => String(variant.id) === String(this.variantInput?.value));
        if (!sourceForm || !selectedVariant?.available) return;
        const checkoutForm = document.createElement('form');
        checkoutForm.method = 'post';
        checkoutForm.action = sourceForm.action;
        checkoutForm.style.display = 'none';
        new FormData(sourceForm).forEach((value, key) => {
          if (typeof value !== 'string') return;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          checkoutForm.append(input);
        });
        const returnTo = document.createElement('input');
        returnTo.type = 'hidden';
        returnTo.name = 'return_to';
        returnTo.value = '/checkout';
        checkoutForm.append(returnTo);
        document.body.append(checkoutForm);
        checkoutForm.submit();
      });
    }

  }

  customElements.define(name, PremiumProductDetail);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-rudraksha-origin-video"] && !Shopify.designMode) return;
  try {
    
(() => {
  const elementName = 'rudraksha-origin-video';
  if (customElements.get(elementName)) return;

  class RudrakshaOriginVideo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.video = this.querySelector('.rudraksha-origin__video');
      this.frame = this.querySelector('[data-origin-video-frame]');
      this.playButton = this.querySelector('[data-origin-play]');
      this.duration = this.querySelector('[data-origin-duration]');
      if (!this.video || !this.frame || !this.playButton) return;

      this.onPlayClick = () => {
        if (this.video.paused) this.video.play().catch(() => {});
        else this.video.pause();
      };
      this.onPlay = () => this.updatePlaybackState(true);
      this.onPause = () => this.updatePlaybackState(false);
      this.onEnded = () => this.updatePlaybackState(false);
      this.onMetadata = () => this.updateDuration();

      this.playButton.addEventListener('click', this.onPlayClick);
      this.video.addEventListener('play', this.onPlay);
      this.video.addEventListener('pause', this.onPause);
      this.video.addEventListener('ended', this.onEnded);
      this.video.addEventListener('loadedmetadata', this.onMetadata);
      this.updateDuration();

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (!entries[0]?.isIntersecting && !this.video.paused) this.video.pause();
        }, { threshold: .15 });
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.playButton?.removeEventListener('click', this.onPlayClick);
      this.video?.removeEventListener('play', this.onPlay);
      this.video?.removeEventListener('pause', this.onPause);
      this.video?.removeEventListener('ended', this.onEnded);
      this.video?.removeEventListener('loadedmetadata', this.onMetadata);
    }

    updatePlaybackState(isPlaying) {
      this.frame.classList.toggle('is-playing', isPlaying);
      this.video.controls = isPlaying;
      this.playButton.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      this.playButton.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    }

    updateDuration() {
      if (!this.duration || !this.video) return;
      const manual = this.duration.dataset.manualDuration?.trim();
      if (manual || !Number.isFinite(this.video.duration)) return;
      const minutes = Math.floor(this.video.duration / 60);
      const seconds = Math.floor(this.video.duration % 60).toString().padStart(2, '0');
      const output = this.duration.querySelector('span');
      if (output) output.textContent = `${minutes}:${seconds}`;
    }
  }

  customElements.define(elementName, RudrakshaOriginVideo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-spotlight-reels"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ELEMENT_NAME = 'spotlight-reels-carousel';
  if (customElements.get(ELEMENT_NAME)) return;

  class SpotlightReelsCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-reels-viewport]');
      this.track = this.querySelector('[data-reels-track]');
      this.previousButton = this.querySelector('[data-reels-previous]');
      this.nextButton = this.querySelector('[data-reels-next]');
      if (!this.viewport || !this.track || this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.delay = Math.max(1000, Number(this.dataset.autoplayDelay) || 3000);
      this.duration = Math.max(0, Number(this.dataset.transitionDuration) || 600);
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.timer = null;
      this.animating = false;
      this.dragging = false;
      this.dragged = false;
      this.startX = 0;
      this.pendingDirection = 0;

      this.onPrevious = () => this.move(-1, true);
      this.onNext = () => this.move(1, true);
      this.onTransitionEnd = (event) => {
        if (event.target === this.track && event.propertyName === 'transform') this.finishMove();
      };
      this.onKeydown = (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.move(-1, true); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.move(1, true); }
      };
      this.onPointerDown = (event) => this.pointerDown(event);
      this.onPointerMove = (event) => this.pointerMove(event);
      this.onPointerUp = (event) => this.pointerUp(event);
      this.onClickCapture = (event) => {
        if (!this.dragged) return;
        event.preventDefault();
        event.stopPropagation();
      };
      this.onVisibilityChange = () => document.hidden ? this.stopAutoplay() : this.startAutoplay();
      this.onMouseEnter = () => !this.centerMode && this.pauseOnHover && this.stopAutoplay();
      this.onMouseLeave = () => this.startAutoplay();
      this.onFocusIn = () => this.stopAutoplay();
      this.onFocusOut = (event) => { if (!this.contains(event.relatedTarget)) this.startAutoplay(); };

      this.previousButton?.addEventListener('click', this.onPrevious);
      this.nextButton?.addEventListener('click', this.onNext);
      this.track.addEventListener('transitionend', this.onTransitionEnd);
      this.viewport.addEventListener('keydown', this.onKeydown);
      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      this.viewport.addEventListener('pointermove', this.onPointerMove);
      this.viewport.addEventListener('pointerup', this.onPointerUp);
      this.viewport.addEventListener('pointercancel', this.onPointerUp);
      this.viewport.addEventListener('click', this.onClickCapture, true);
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      this.setupSoundControls();
      this.setupVideoObserver();
      this.resizeObserver = new ResizeObserver(() => this.queueBuild());
      this.resizeObserver.observe(this.viewport);
      this.build();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.videoObserver?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.buildFrame);
      window.clearTimeout(this.transitionFallback);
      this.previousButton?.removeEventListener('click', this.onPrevious);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('transitionend', this.onTransitionEnd);
      this.viewport?.removeEventListener('keydown', this.onKeydown);
      this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
      this.viewport?.removeEventListener('pointermove', this.onPointerMove);
      this.viewport?.removeEventListener('pointerup', this.onPointerUp);
      this.viewport?.removeEventListener('pointercancel', this.onPointerUp);
      this.viewport?.removeEventListener('click', this.onClickCapture, true);
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.dataset.initialized = 'false';
    }

    get slides() { return Array.from(this.track.children); }

    get perView() {
      return Math.max(1, Number.parseFloat(getComputedStyle(this).getPropertyValue('--sr-current-per-view')) || 1);
    }

    get gap() {
      const styles = getComputedStyle(this.track);
      return Number.parseFloat(styles.columnGap || styles.gap) || 0;
    }

    get centerMode() { return window.matchMedia('(max-width: 749px)').matches; }

    get canMove() {
      return this.centerMode ? this.slides.length > 1 : this.slides.length > Math.ceil(this.perView);
    }

    get baseTranslate() {
      if (!this.centerMode || !this.slides[0]) return 0;
      const slideWidth = this.slides[0].getBoundingClientRect().width;
      return ((this.viewport.clientWidth - slideWidth) / 2) - (slideWidth + this.gap);
    }

    queueBuild() {
      cancelAnimationFrame(this.buildFrame);
      this.buildFrame = requestAnimationFrame(() => this.build());
    }

    build() {
      if (!this.viewport.clientWidth) return;
      this.slides
        .sort((a, b) => Number(a.dataset.reelIndex) - Number(b.dataset.reelIndex))
        .forEach((slide) => this.track.append(slide));
      if (this.centerMode && this.slides.length > 1) this.track.prepend(this.track.lastElementChild);

      const width = this.centerMode
        ? Math.max(1, this.viewport.clientWidth * .504)
        : Math.max(1, (this.viewport.clientWidth - (this.gap * (this.perView - 1))) / this.perView);
      this.style.setProperty('--sr-slide-width', `${width}px`);
      this.track.style.transition = 'none';
      this.track.style.transform = `translate3d(${this.baseTranslate}px,0,0)`;
      this.animating = false;
      this.pendingDirection = 0;
      if (this.previousButton) this.previousButton.disabled = !this.canMove;
      if (this.nextButton) this.nextButton.disabled = !this.canMove;
      this.startAutoplay();
    }

    move(direction, userInitiated = false) {
      if (!this.canMove || this.animating || this.dragging) return;
      // Keep the mobile clock running so slide starts stay three seconds apart.
      if (!this.centerMode) this.stopAutoplay();
      this.animating = true;
      this.pendingDirection = direction;
      const step = this.slides[0].getBoundingClientRect().width + this.gap;
      const base = this.baseTranslate;

      if (direction < 0) {
        this.track.insertBefore(this.track.lastElementChild, this.track.firstElementChild);
        this.track.style.transition = 'none';
        this.track.style.transform = `translate3d(${base - step}px,0,0)`;
        this.track.getBoundingClientRect();
        requestAnimationFrame(() => {
          this.track.style.transition = `transform ${this.duration}ms cubic-bezier(.22,.61,.36,1)`;
          this.track.style.transform = `translate3d(${base}px,0,0)`;
        });
      } else {
        this.track.style.transition = `transform ${this.duration}ms cubic-bezier(.22,.61,.36,1)`;
        this.track.style.transform = `translate3d(${base - step}px,0,0)`;
      }

      window.clearTimeout(this.transitionFallback);
      this.transitionFallback = window.setTimeout(() => this.finishMove(), this.duration + 100);
      if (userInitiated) this.restartAfterInteraction = true;
    }

    finishMove() {
      if (!this.animating) return;
      window.clearTimeout(this.transitionFallback);
      if (this.pendingDirection > 0 && this.track.firstElementChild) this.track.append(this.track.firstElementChild);
      this.track.style.transition = 'none';
      this.track.style.transform = `translate3d(${this.baseTranslate}px,0,0)`;
      this.animating = false;
      this.pendingDirection = 0;
      if (!this.centerMode || !this.timer) this.startAutoplay();
    }

    pointerDown(event) {
      if (!this.canMove || this.animating || (event.button !== undefined && event.button !== 0) || event.target.closest('button, iframe')) return;
      this.dragging = true;
      this.dragged = false;
      this.startX = event.clientX;
      this.track.style.transition = 'none';
      this.viewport.classList.add('is-dragging');
      this.viewport.setPointerCapture?.(event.pointerId);
      this.stopAutoplay();
    }

    pointerMove(event) {
      if (!this.dragging) return;
      const distance = event.clientX - this.startX;
      if (Math.abs(distance) > 6) this.dragged = true;
      this.track.style.transform = `translate3d(${this.baseTranslate + distance}px,0,0)`;
    }

    pointerUp(event) {
      if (!this.dragging) return;
      const distance = event.clientX - this.startX;
      this.dragging = false;
      this.viewport.classList.remove('is-dragging');
      this.viewport.releasePointerCapture?.(event.pointerId);
      this.track.style.transform = `translate3d(${this.baseTranslate}px,0,0)`;
      const threshold = Math.min(60, this.viewport.clientWidth * .12);
      if (Math.abs(distance) > threshold) this.move(distance < 0 ? 1 : -1, true);
      else {
        this.track.style.transition = `transform ${Math.min(this.duration, 300)}ms ease`;
        this.startAutoplay();
      }
      window.setTimeout(() => { this.dragged = false; }, 0);
    }

    setupSoundControls() {
      this.querySelectorAll('[data-sound-toggle]').forEach((button) => {
        const video = button.closest('.spotlight-reels__media')?.querySelector('video');
        if (!video) return;
        video.muted = true;
        video.defaultMuted = true;
        button.addEventListener('click', () => {
          const turnSoundOn = video.muted;
          if (turnSoundOn) {
            this.querySelectorAll('video').forEach((otherVideo) => { if (otherVideo !== video) otherVideo.muted = true; });
          }
          video.muted = !turnSoundOn;
          video.play().catch(() => {});
          this.updateSoundButtons();
        });
        video.addEventListener('volumechange', () => this.updateSoundButtons());
      });
      this.updateSoundButtons();
    }

    updateSoundButtons() {
      this.querySelectorAll('[data-sound-toggle]').forEach((button) => {
        const video = button.closest('.spotlight-reels__media')?.querySelector('video');
        const soundOn = video && !video.muted;
        button.classList.toggle('is-sound-on', Boolean(soundOn));
        button.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
        button.setAttribute('aria-label', soundOn ? 'Mute reel' : 'Turn sound on');
      });
    }

    setupVideoObserver() {
      if (!('IntersectionObserver' in window)) {
        this.querySelectorAll('video').forEach((video) => video.play().catch(() => {}));
        return;
      }
      this.videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= .45 && !document.hidden) video.play().catch(() => {});
          else video.pause();
        });
      }, { root: this.viewport, threshold: [0, .45, 1] });
      this.querySelectorAll('video').forEach((video) => this.videoObserver.observe(video));
    }

    startAutoplay() {
      this.stopAutoplay();
      if ((!this.centerMode && !this.autoplayEnabled) || this.reducedMotion.matches || document.hidden || !this.canMove) return;
      this.timer = window.setInterval(() => this.move(1), this.centerMode ? 3000 : this.delay);
    }

    stopAutoplay() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    selectBlock(blockId) {
      const target = this.slides.find((slide) => slide.dataset.blockId === blockId);
      if (!target) return;
      const activeSlide = () => this.centerMode ? this.track.children[1] : this.track.firstElementChild;
      while (activeSlide() !== target) this.track.append(this.track.firstElementChild);
      this.track.style.transition = 'none';
      this.track.style.transform = `translate3d(${this.baseTranslate}px,0,0)`;
      this.stopAutoplay();
      target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  customElements.define(ELEMENT_NAME, SpotlightReelsCarousel);

  document.addEventListener('shopify:block:select', (event) => {
    event.target.closest(ELEMENT_NAME)?.selectBlock(event.detail.blockId);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-why-rudraksha"] && !Shopify.designMode) return;
  try {
    
(() => {
  const elementName = 'why-rudraksha-section';
  if (customElements.get(elementName)) return;

  class WhyRudrakshaSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.viewport = this.querySelector('[data-why-carousel]');
      this.track = this.querySelector('[data-why-track]');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplay = this.dataset.autoplay === 'true';
      this.delay = Math.max(1000, Number(this.dataset.autoplayDelay) || 5000);
      this.duration = Math.max(0, Number(this.dataset.transitionDuration) || 500);
      this.animating = false;
      this.dragging = false;
      this.pendingDirection = 0;
      this.inViewport = true;

      if (!this.viewport || !this.track || this.track.children.length < 2) return;

      this.onTransitionEnd = (event) => {
        if (event.target === this.track && event.propertyName === 'transform') this.finishMove();
      };
      this.onMediaChange = () => this.updateMode();
      this.onVisibilityChange = () => document.hidden ? this.stopAutoplay() : this.startAutoplay();

      this.track.addEventListener('transitionend', this.onTransitionEnd);
      this.viewport.addEventListener('pointerdown', (event) => this.pointerDown(event));
      this.viewport.addEventListener('pointermove', (event) => this.pointerMove(event));
      this.viewport.addEventListener('pointerup', (event) => this.pointerUp(event));
      this.viewport.addEventListener('pointercancel', (event) => this.pointerUp(event));
      this.viewport.addEventListener('mouseenter', () => this.stopAutoplay());
      this.viewport.addEventListener('mouseleave', () => this.startAutoplay());
      this.viewport.addEventListener('focusin', () => this.stopAutoplay());
      this.viewport.addEventListener('focusout', (event) => { if (!this.viewport.contains(event.relatedTarget)) this.startAutoplay(); });
      this.viewport.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      });
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      if (this.mobileQuery.addEventListener) this.mobileQuery.addEventListener('change', this.onMediaChange);
      else this.mobileQuery.addListener(this.onMediaChange);
      if ('IntersectionObserver' in window) {
        this.sectionObserver = new IntersectionObserver((entries) => {
          this.inViewport = Boolean(entries[0]?.isIntersecting);
          this.inViewport ? this.startAutoplay() : this.stopAutoplay();
        }, { threshold: .08 });
        this.sectionObserver.observe(this);
      }
      this.updateMode();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      window.clearTimeout(this.fallbackTimer);
      window.clearTimeout(this.resumeTimer);
      this.sectionObserver?.disconnect();
      this.track?.removeEventListener('transitionend', this.onTransitionEnd);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      if (this.mobileQuery?.removeEventListener) this.mobileQuery.removeEventListener('change', this.onMediaChange);
      else this.mobileQuery?.removeListener?.(this.onMediaChange);
    }

    updateMode() {
      this.stopAutoplay();
      window.clearTimeout(this.fallbackTimer);
      this.animating = false;
      this.dragging = false;
      this.pendingDirection = 0;
      this.track.style.transition = 'none';
      this.track.style.transform = 'translate3d(0,0,0)';
      this.viewport.classList.remove('is-dragging');
      this.startAutoplay();
    }

    canMove() {
      return this.mobileQuery.matches && this.track && this.track.children.length > 1;
    }

    stepFor(element = this.track.firstElementChild) {
      if (!element) return 0;
      const styles = getComputedStyle(this.track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      return element.getBoundingClientRect().width + gap;
    }

    move(direction = 1) {
      if (!this.canMove() || this.animating || this.dragging) return;
      this.stopAutoplay();
      this.animating = true;
      this.pendingDirection = direction;

      if (direction < 0) {
        const last = this.track.lastElementChild;
        this.track.insertBefore(last, this.track.firstElementChild);
        const step = this.stepFor(last);
        this.track.style.transition = 'none';
        this.track.style.transform = `translate3d(${-step}px,0,0)`;
        this.track.getBoundingClientRect();
        requestAnimationFrame(() => {
          this.track.style.transition = `transform ${this.duration}ms cubic-bezier(.22,.61,.36,1)`;
          this.track.style.transform = 'translate3d(0,0,0)';
        });
      } else {
        const step = this.stepFor();
        this.track.style.transition = `transform ${this.duration}ms cubic-bezier(.22,.61,.36,1)`;
        this.track.style.transform = `translate3d(${-step}px,0,0)`;
      }

      window.clearTimeout(this.fallbackTimer);
      this.fallbackTimer = window.setTimeout(() => this.finishMove(), this.duration + 120);
    }

    finishMove() {
      if (!this.animating) return;
      window.clearTimeout(this.fallbackTimer);
      if (this.pendingDirection > 0 && this.track.firstElementChild) this.track.append(this.track.firstElementChild);
      this.track.style.transition = 'none';
      this.track.style.transform = 'translate3d(0,0,0)';
      this.animating = false;
      this.pendingDirection = 0;
      this.startAutoplay();
    }

    pointerDown(event) {
      if (!this.canMove() || this.animating || (event.button !== undefined && event.button !== 0)) return;
      this.dragging = true;
      this.startX = event.clientX;
      this.track.style.transition = 'none';
      this.viewport.classList.add('is-dragging');
      this.viewport.setPointerCapture?.(event.pointerId);
      this.stopAutoplay();
    }

    pointerMove(event) {
      if (!this.dragging) return;
      const distance = event.clientX - this.startX;
      if (Math.abs(distance) < 4) return;
      this.track.style.transform = `translate3d(${distance}px,0,0)`;
    }

    pointerUp(event) {
      if (!this.dragging) return;
      const distance = event.clientX - this.startX;
      this.dragging = false;
      this.viewport.classList.remove('is-dragging');
      this.viewport.releasePointerCapture?.(event.pointerId);

      if (distance < -40) {
        const step = this.stepFor();
        this.animating = true;
        this.pendingDirection = 1;
        this.track.style.transition = `transform ${this.duration}ms cubic-bezier(.22,.61,.36,1)`;
        this.track.style.transform = `translate3d(${-step}px,0,0)`;
        window.clearTimeout(this.fallbackTimer);
        this.fallbackTimer = window.setTimeout(() => this.finishMove(), this.duration + 120);
        return;
      }

      if (distance > 40) {
        this.track.style.transition = 'none';
        this.track.style.transform = 'translate3d(0,0,0)';
        this.move(-1);
        return;
      }

      this.track.style.transition = `transform ${Math.min(240, this.duration)}ms ease`;
      this.track.style.transform = 'translate3d(0,0,0)';
      window.clearTimeout(this.resumeTimer);
      this.resumeTimer = window.setTimeout(() => this.startAutoplay(), Math.min(240, this.duration));
    }

    startAutoplay() {
      this.stopAutoplay();
      if (!this.autoplay || !this.canMove() || this.reducedMotion.matches || document.hidden || !this.inViewport) return;
      this.timer = window.setInterval(() => this.move(1), this.delay);
    }

    stopAutoplay() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    selectBlock(blockId) {
      if (!this.mobileQuery.matches || !this.track) return;
      const target = Array.from(this.track.children).find((slide) => slide.dataset.blockId === blockId);
      if (!target) return;
      while (this.track.firstElementChild !== target) this.track.append(this.track.firstElementChild);
      this.track.style.transition = 'none';
      this.track.style.transform = 'translate3d(0,0,0)';
      this.stopAutoplay();
    }
  }

  customElements.define(elementName, WhyRudrakshaSection);

  document.addEventListener('shopify:block:select', (event) => {
    event.target.closest(elementName)?.selectBlock(event.detail.blockId);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();
})();
